export default __webpack_public_path__ + "static/media/ndvi1.8f2aca01.PNG";